/* @flow */
import * as React from 'react';

// Styles
import styles from './BraindateParticipantsList.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import messages from 'src/shared/app/braindate/l10n/braindateL10n';
import { useIntl } from 'react-intl';

// Components
import Heading from 'src/shared/ui/text/Heading';
import { SwipeableDrawer } from '@mui/material';
import BraindateParticipantsListItem from './BraindateParticipantsListItem';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import type { BraindateParticipantListElement } from './BraindateParticipants';

type Props = {
  participants: User[],
  columns: BraindateParticipantListElement[],
  onClose: () => void,
};

const useStyles = createUseThemeStyles(styles);

const BraindateParticipantsList = ({
  participants,
  columns,
  onClose,
}: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <SwipeableDrawer
      open
      anchor="bottom"
      onOpen={() => {}}
      onClose={onClose}
      keepMounted={false}
      disableDiscovery
      disableSwipeToOpen
      classes={{ paper: classes.root }}
    >
      <>
        <Heading layoutClass={classes.title}>
          {intl.formatMessage(messages.participantsListCount, {
            count: participants.length,
          })}
        </Heading>
        <div className={classes.content}>
          {participants.map((participant, key) => (
            <BraindateParticipantsListItem
              participant={participant}
              columns={columns}
              onClose={onClose}
              key={key}
            />
          ))}
        </div>
      </>
    </SwipeableDrawer>
  );
};

export default React.memo<Props>(BraindateParticipantsList);
